import React from "react";
import { Button, TextField, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { rejectMultiplePG,rejectMultipleCG, getCustomerGroups, getProductGroups, setState } from "./cgpgSlice";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	boxShadow: 24,
	borderRadius: 1,
	p: 3,
};

export default function RejectSelectedModal() {
   const dispatch = useDispatch();
   const {
      rejectMultiModalOpen,
      rejectSelectedComment,
      selectedRows,
      selectedPeriod,
      selectedCountryID,
      selectedGroupStatus,
      selectedView,
      productGroups, 
      customerGroups,
      searchText,
   } = useSelector((store) => store.cgpgApproval);

   function handleClose() {
      dispatch(setState("rejectMultiModalOpen", false));
      dispatch(setState("rejectSelectedComment",''));
   }

   function setComment(event) {
      const comment = event.target.value;
      dispatch(setState("rejectSelectedComment", comment));
   }

   function search() {
      dispatch(setState("customerGroups", null));
      dispatch(setState("productGroups", null));
      dispatch(setState("rejectSelectedComment", ''));
      dispatch(setState("selectedRows", []));

		const obj = {
			logedUser: JSON.parse(localStorage.getItem("data")),
			countryId: selectedCountryID,
			groupStatus: selectedGroupStatus,
			period: selectedPeriod,
			searchText: searchText,
		};

		if (selectedView === "Product Group") {
			dispatch(getProductGroups(obj));
		} else {
			dispatch(getCustomerGroups(obj));
		}
	}

   function rejectSelected() {
      const user = JSON.parse(localStorage.getItem("data"));

      let itemList = [];
      for (let i = 0; i < selectedRows.length; ++i) {
         const id = selectedRows[i];

         let item = null;

         if(selectedView === "Product Group") {
            item = productGroups.find((pg) => pg.productGroupID === id);
         }
         else {
            item = customerGroups.find((cg) => cg.customerGroupID === id);
         }
         item = {
            ...item,
            //comments: rejectSelectedComment,
            comments: item.comments
					? `${item.comments}\n${rejectSelectedComment}`
					: rejectSelectedComment ,
            isApprove: 0,
         };
         const obj = {
            ...item,
            user,
         };

         itemList.push(obj);
      }
      console.log("Approve_CGPG_ApproveRejectSelected", itemList);

      if(selectedView === "Product Group") {
         dispatch(rejectMultiplePG(itemList)).then(() => {
            handleClose();
            search();
         });
      }
      else {
         dispatch(rejectMultipleCG(itemList)).then(() => {
            handleClose();
            search();
         });
      }
   }

   return (
      <Box>
         <Modal open={rejectMultiModalOpen} onClose={handleClose}>
            <Box sx={style}>
               <Typography variant="subtitle2">Comments</Typography>
               <TextField 
                  value={rejectSelectedComment}
                  className={'fullWidth'}
						size="large"
						multiline
						rows={6}
						style={{overflowY:'auto'}}
						onChange={setComment}
               />
               <br />
               <Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
               <Button
							sx={{
								bgcolor: "darkred.light",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								mr: 2,
								"&:hover": {
									bgcolor: "darkred.main",
								},
							}}
							onClick={handleClose}
						>
							Close
						</Button>
               <Button
                  sx={{
                     bgcolor: "darkred.light",
                     color: "white.main",
                     textTransform: "none",
                     mt: 1,
                     "&:hover": {
                        bgcolor: "darkred.main",
                     },
                  }}
                  onClick={rejectSelected}
               >
                  Reject
               </Button>
               </Box>
            </Box>
         </Modal>
      </Box>
   );
}
